export default "__VITE_ASSET__BLcU73aj__"